import { Component, Input } from '@angular/core';
import { IBooking } from 'src/app/models';
import { images } from 'src/images';

@Component({
    selector: 'app-seats',
    templateUrl: './seats.component.html',
    styleUrl: './seats.component.scss',
    standalone: false
})
export class SeatsComponent {
  @Input() booking: IBooking;
  public images = images;
}
